import React from "react";
import ReactQuill from "react-quill";
import { useDispatch } from "react-redux";
import { updateItemQuestion } from "../../Redux/Reducer/FormSlices";

const LocationQuestion = ({
  id,
  question,
  module,
  questionIndex,
  openQuestion,
  setOpenQuestion,
  containerIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  console.log(question)
  return (
    <>
      <div className="singleQuestion_name_Container">
        {questionIndex + 1}.
        <ReactQuill
          modules={module}
          theme="snow"
          className={`custom ${openQuestion === question.id ? "focus" : ""}`}
          onFocus={() => setOpenQuestion(question.id)}
          onBlur={() => setOpenQuestion(null)}
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="address-container">
        {question.address?.map(
          (address, i) =>
            address.type === "address" && (
              <div className="addresslineone"key={i} >
                <p>{address.placeHolder}</p>
              </div>
            )
        )}
        <div className="other-details-container">
          {question.address?.map(
            (address,i) =>
              address.type === "text" && (
                <div className="addresslineone" key={i}>
                  <p>{address.placeHolder}</p>
                </div>
              )
          )}
        </div>
      </div>
    </>
  );
};

export default LocationQuestion;
